export const getSafeRedirectPath = (from) => {
  let path = null;
  if (typeof from === 'string') {
    path = from;
  } else if (from && typeof from.pathname === 'string') {
    path = `${from.pathname}${from.search || ''}${from.hash || ''}`;
  }
  if (!path || !path.startsWith('/') || path.startsWith('//') || path.includes('\\')) return null;
  if ([...path].some((ch) => ch.charCodeAt(0) < 32)) return null;
  try {
    const base = window.location.origin;
    const url = new URL(path, base);
    if (url.origin !== base) return null;
    const result = `${url.pathname}${url.search}${url.hash}`;
    return result === '/' ? null : result;
  } catch {
    return null;
  }
};
